// services import
import { SidAutoRedirect } from './sid-auto-redirect';
import { Account } from './account';
import { AppNameProvider } from './app-name';
import { ApplicationAuthorization } from './application-authorization';
import { Applications } from './applications';
import { Buffer } from './buffer';
import { ChartColorsProvider } from './chart-colors';
import { ConnectionStatus } from './connection-status';
import { Country } from './country';
import { Currencies } from './currencies';
import { DateHelper } from './date-helper';
import { EmailRegexProvider } from './email-regex';
import { Feeds } from './feeds';
import { InterTab } from './inter-tab';
import { KeyStreams } from './key-streams';
import { Languages } from './languages';
import { LazyLoadFactory } from './lazy-load';
import { LocalDraft } from './local-draft';
import { LocalDraftCollectionsProvider } from './local-draft-collections';
import { LocationStreams } from './location-streams';
import { Navigate } from './navigate';
import { ObservableOfProvider } from './observable-of';
import { OrderTerms } from './order-terms';
import { OsSniffer } from './os-sniffer';
import { PackingList } from './packing-list';
import { PathStreams } from './path-streams';
import { PeriodTypeProvider } from './period-type';
import { Playlist } from './playlist';
import { PrintQueue } from './print-queue';
import { Receivings } from './receivings';
import { Redraw } from './redraw';
import { RelativeDate } from './relative-date';
import { Replenishment } from './replenishment';
import { Report } from './report';
import { RouteDateFormatProvider } from './route-date-format';
import { RouteNormalizer } from './route-normalizer';
import { RouteParamsStreams } from './route-params-streams';
import { SalesDashboard } from './sales-dashboard';
import { SecondScreen } from './second-screen';
import { Settings } from './settings';
import { SidebarManager } from './sidebar-manager';
import { SpynlBaseDefault } from '@shared/app/scripts/services/spynl-base';
import { StatePersistence } from './state-persistence';
import { SwDexie } from './sw-dexie';
import { SwLocation } from './sw-location';
import { SwServiceWorker } from './service-worker';
import { SyncRequests } from './sync-requests';
import { Tenant } from './tenant';
import { Token } from './token';
import { Transaction } from './transaction';
import { Uploader } from './uploader';
import { User } from './user';
import { WindowStreams } from './window-streams';
import { WithCredentialsInterceptorProvider } from './with-credentials-interceptor';
import { IframeManager } from './iframe-manager';

export const services: any[] = [
  // services export
  SidAutoRedirect,
  Account,
  AppNameProvider,
  ApplicationAuthorization,
  Applications,
  Buffer,
  ChartColorsProvider,
  ConnectionStatus,
  Country,
  Currencies,
  DateHelper,
  EmailRegexProvider,
  Feeds,
  InterTab,
  KeyStreams,
  Languages,
  LazyLoadFactory,
  LocalDraft,
  LocalDraftCollectionsProvider,
  LocationStreams,
  Navigate,
  ObservableOfProvider,
  OrderTerms,
  OsSniffer,
  PackingList,
  PathStreams,
  PeriodTypeProvider,
  Playlist,
  PrintQueue,
  Receivings,
  Redraw,
  RelativeDate,
  Replenishment,
  Report,
  RouteDateFormatProvider,
  RouteNormalizer,
  RouteParamsStreams,
  SalesDashboard,
  SecondScreen,
  Settings,
  SidebarManager,
  SpynlBaseDefault,
  StatePersistence,
  SwDexie,
  SwLocation,
  SwServiceWorker,
  SyncRequests,
  Tenant,
  Token,
  Transaction,
  Uploader,
  User,
  WindowStreams,
  WithCredentialsInterceptorProvider,
  IframeManager,
];
